import { useState, useEffect } from "react";
import { socket } from "../App";
import { useDispatch, useSelector } from "react-redux";
import {
  getPremiumFeeAction,
  saveSpotPremiumPrice,
  saveSpotPrice,
  saveCryptoPrice,
  saveProfitPrice,
  saveEquityPrice,
  saveCoinRates
} from "../features/user/userSlice";
import { spotPlusPremium } from "../utils/utils";
import { store } from "../app/store";

export const useSocketService = () => {
  const dispatch = useDispatch();

  const [isSocket, setIsSocket] = useState(true);
  const [isActive, setIsActive] = useState(false);
  const [premiumPrice, setPremiumPrice] = useState([]);
  const isUserLoggedIn = useSelector((state) => state.persist.isUserLoggedin);

  useEffect(() => {
    if (isUserLoggedIn) {
      adminPremiumFee();
    }
  }, [isUserLoggedIn]);

  const adminPremiumFee = async () => {
    try {
      const response = await dispatch(getPremiumFeeAction());
      if (response.status === 200) {      
        setPremiumPrice(response.data?.data);
      }
    } catch (error) {}
  };

  const publicListenersOn = () => {
    socket.on("SPOT_PRICE", (response) => {
      dispatch(saveSpotPrice(response));

      if (Array.isArray(premiumPrice)) {
        let goldPremiumPrice = premiumPrice.filter(
          (elem) => elem.token_id === 1
        )[0];
        let silverPremiumPrice = premiumPrice.filter(
          (elem) => elem.token_id === 2
        )[0];

        // Dispatching spot + premium prices
        dispatch(
          saveSpotPremiumPrice({
            goldPrice: Number(
              spotPlusPremium(
                response.goldPrice,
                goldPremiumPrice?.fee_value,
                goldPremiumPrice?.type
              )
            ),
            silverPrice: Number(
              spotPlusPremium(
                response.silverPrice,
                silverPremiumPrice?.fee_value,
                silverPremiumPrice?.type
              )
            ),
          })
        );
      } else {
      }
    });

    socket.on("CRYPTO_PRICE", (response) => {
      dispatch(saveCryptoPrice(response));
    });


    socket.on("COIN_RATES", (response) => {
      dispatch(saveCoinRates(response));
    });
    socket.on("TOTAL_PROFIT_DISTRIBUTION", (response) => {
      dispatch(saveProfitPrice(response));
    });

    socket.on("EQUITY_PRICE", (response) => {
      dispatch(saveEquityPrice(response));
    });

    
  };

  let trya = 0;
  const retryConnect = () => {
    let aa = setInterval(() => {
      if (trya === 0) {
        socket.connect();
      } else {
        clearInterval(aa);
      }
    }, 1000);
  };

  useEffect(() => {
    if (isSocket) {
      socket.removeAllListeners();
      socket.on("disconnect", () => {
        trya = 0;
        retryConnect();
      });
      socket.on("connect", () => {
        trya = 1;
        socket.removeAllListeners();
        publicListenersOn();
      });
      publicListenersOn();
    }
    setIsActive(true);
    return () => {
      socket.removeAllListeners();
      setIsActive(false);
    };
  }, [socket?.id, premiumPrice]);

  return isActive;
};
